"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityDimensionTypeToJSON = exports.EntityDimensionTypeFromJSONTyped = exports.EntityDimensionTypeFromJSON = exports.EntityDimensionType = void 0;
/**
 * EntityDimensionType describes the top-level entity in the ad hierarchy that a particular
 * report will be based off of. Both Aggregate and Insight Reports require an
 * EntityDimensionType.
 *
 * @export
 */
exports.EntityDimensionType = {
    Ad: 'AD',
    AdSet: 'AD_SET',
    Campaign: 'CAMPAIGN',
    AdAccount: 'AD_ACCOUNT'
};
function EntityDimensionTypeFromJSON(json) {
    return EntityDimensionTypeFromJSONTyped(json, false);
}
exports.EntityDimensionTypeFromJSON = EntityDimensionTypeFromJSON;
function EntityDimensionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.EntityDimensionTypeFromJSONTyped = EntityDimensionTypeFromJSONTyped;
function EntityDimensionTypeToJSON(value) {
    return value;
}
exports.EntityDimensionTypeToJSON = EntityDimensionTypeToJSON;
